import { Helmet } from "react-helmet-async";

// Marketing-only display/mono typefaces (Fraunces + Inter + JetBrains
// Mono) — loaded here rather than public/index.html so the actual
// QR-menu ordering flow guests use on their phones never pays for fonts
// it doesn't render. Shared by the landing page and every marketing
// static page (About/Contact/Privacy/Terms) so they carry the exact
// same type system.
function MarketingFonts() {
  return (
    <Helmet>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true" />
      <link
        href="https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,300..900;1,9..144,300..900&family=Inter:wght@400;500;600;700;800&family=JetBrains+Mono:wght@400;500;600;700&display=swap"
        rel="stylesheet"
      />
    </Helmet>
  );
}

export default MarketingFonts;
